import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

import { TextField } from '@material-ui/core';

import { useStyles } from './styles.js';

class InputField extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  /** LIFE CYCLE METHODS */
  componentDidMount() {}

  handleDateChange(chapter, date) {}

  /**RENDER METHOD */
  render() {
    const { classes } = this.props;

    return (
      <TextField
        fullWidth
        margin="dense"
        label={
          this.props.show_label && (
            <label>
              {this.props.label} *
              <span className={classes.requiredAsterisk}> *</span>
            </label>
          )
        }
        InputLabelProps={{
          shrink: true,
          style: { fontSize: 20, top: '-5px', fontWeight: 'bold' },
        }}
        {...this.props}
      />
    );
  }
}

InputField.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(InputField);
